// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"SignupJumbotron_CloseButton__3HDhR"};